import ClickOutsideWrapper from "./ClickOutsideWrapper";

export default ClickOutsideWrapper;
